import { DownloadOutlined, EditOutlined } from '@ant-design/icons';
import { Table } from 'ant-table-extensions';
import { Tooltip, Typography } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { useEffect, useState } from 'react';
import { Address, getAddressByPersonID } from '../../../api/NetworkingAddresses';
import { getResource } from '../../../helpers/ResourcesHelper';
import Button from '../../inputs/Button';
import AddressForm from './addresses/Address';
interface Item extends Address {
  isNew: boolean;
}

const Addresses = () => {
  const [addresses, setAddresses] = useState<Address[]>([]);
  const [updating, setUpdating] = useState(false);

  const [currentAddressID, setCurrentAddressID] = useState('');
  const [editAddress, setEditAddress] = useState(false);
  const [newAddress, setNewAddress] = useState(false);

  // const [currentPage, setCurrentPage] = useState(1);

  // const [filteringSomething, setFilteringSomething] = useState(false);
  // const [searchText, setSearchText] = useState('');
  // const [searchedColumn, setSearchedColumn] = useState('');
  // const [searchArray, setSearchArray] = useState({});
  // const searchInput = useRef();

  useEffect(() => {
    const loadAddresses = async () => {
      const personID = localStorage.getItem('CustomerPersonID')!;
      const json = await getAddressByPersonID(personID);
      if (json != null && json.addresses != null) {
        const addresses = json.addresses.map((a: Address, index: number) => ({ ...a, key: a['Address ID'], order: `address-${index + 1}` }));
        setAddresses(addresses);
      }
    };
    loadAddresses();
  }, [updating]);

  const edit = (record: Address) => {
    setCurrentAddressID(record['Address ID']);
    setEditAddress(true);
  };

  const handleBackLink = () => {
    setCurrentAddressID('');
    setEditAddress(false);
    setNewAddress(false);
    setUpdating(!updating);
  };

  const columns: ColumnsType<Address> = [
    {
      title: getResource('Label.AddressType'),
      dataIndex: 'Address Type',
      key: 'Address Type',
      align: 'left',
      fixed: 'left'
    },
    {
      title: getResource('Label.Address'),
      dataIndex: 'Address',
      key: 'Address',
      align: 'left'
    },
    /*{
      title: 'Address 2',
      dataIndex: 'Address2$',
      key: 'Address2$',
      align: 'left'
    },*/
    {
      title: getResource('Label.Country'),
      dataIndex: 'Country',
      key: 'Country',
      align: 'left'
    },
    {
      title: getResource('Label.ProvinceState'),
      dataIndex: 'State',
      key: 'State',
      align: 'left'
    },
    {
      title: getResource('Label.City'),
      dataIndex: 'City',
      key: 'City',
      align: 'left'
    },
    {
      title: getResource('Label.ZipCode'),
      dataIndex: 'ZipCode$',
      key: 'ZipCode$',
      align: 'center'
    },
    {
      title: getResource('Label.SinceWhen'),
      dataIndex: 'SinceWhen$',
      key: 'SinceWhen$',
      align: 'center'
    },
    {
      title: getResource('Table_TH_Actions'),
      dataIndex: 'Actions',
      align: 'center',
      width: '10%',
      fixed: 'right',
      render: (_: any, record: Address) => (
        <>
          <Tooltip title={getResource('Js.Link.Edit')}>
            <Typography.Link key={`${record.order}`} id={`${record.order}-edit`}
              onClick={() => edit(record)}
            >
              <EditOutlined style={{fontSize: 18}}/>
            </Typography.Link>
          </Tooltip>
        </>
      )
    }
  ];

  if (editAddress || newAddress) {
    return <AddressForm key="address-form" addressID={newAddress ? '' : currentAddressID} handleBackLink={handleBackLink} />;
  }

  return (
    <div className="row center-xs">
      <div className="col-md-4 col-xs-12">
        <Button
          id="contacts-add-contact"
          type="secondary"
          onClick={() => { setNewAddress(true); }}
        >{getResource('AddAddress')}</Button>
      </div>
      <div className="col-md-10 col-xs-12">
        <Table
          columns={columns}
          dataSource={addresses}
          exportableProps={{
            fileName: 'Addresses',
            btnProps: {
              type: "default",
              icon: <DownloadOutlined />,
            }
          }}
        />
      </div>
    </div>
  );
};

export default Addresses;
